let stripe = null;
let elements = null;
let cardElement = null;
let addressElement = null;
let paymentElement = null;
let responseCheckout;

export const initStripe = (accountId, accountPublicKey) => {
    if (accountPublicKey) {
        stripe = Stripe(accountPublicKey);
    } else {
        stripe = Stripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY, {
            stripeAccount: accountId,
        });
    }
}

const appearance = {
    theme: 'stripe',
    variables: {
        colorPrimary: '#CD7768',
        fontFamily: "'TenorSans', sans-serif",
    },
    rules: {
        '.Input': {
            border: '2px solid #CD7768',
        }
    }
};
const options = {
    mode: 'shipping',
    autocomplete: {
        mode: 'google_maps_api',
        apiKey: import.meta.env.VITE_BEAUTYDOSE_STRIPE_ADDRESS_API_KEY,
    },
    allowedCountries: ['MX'],
    fields: {
        phone: 'always',
    },
    validation: {
        phone: {
            required: 'always',
        }
    }
}
export const createCardElement = (options = null) => {
    elements = stripe.elements();
    cardElement = elements.create('card', options);
}

export const createAddressElement = () => {
    elements = stripe.elements({ appearance });
    addressElement = elements.create('address', options);
}

export const createPaymentElement = (clientSecret, paymentElementOptions = null) => {
    elements = stripe.elements({ clientSecret });
    paymentElement = elements.create("payment", paymentElementOptions);
}

export const mountPaymentElement = () => {
    paymentElement.mount("#payment-element");
};

export const mountAddressElement = () => {
    addressElement.mount("#address-element");
};

export const getAddressData = async () => {
    const customerInfo = elements.getElement('address');
    const { complete, value } = await customerInfo.getValue();
    return {
        complete,
        value
    };
}

export const mountCheckout = async (clientSecret) => {
    responseCheckout = await stripe.initEmbeddedCheckout({
        clientSecret: clientSecret,
    });

    responseCheckout.mount('#checkout');
}

export const unmountCheckout = async () => {
    if (responseCheckout) {
        responseCheckout.destroy('#checkout');
    }
}

export const mountStripeCard = () => {
    cardElement.mount("#card-element");
};

export const createPaymentMethod = async (customerName) => {
    return await stripe.createPaymentMethod({
        elements,
        params: {
            billing_details: {
                name: customerName,
            },
        },
    }).then(function (result) {
        return (result.paymentMethod)
    });
}

export const confirmSetupIntent = async (setupIntent, cardName) => {
    const cardElement = elements.getElement('card');
    return await stripe.confirmCardSetup(setupIntent, {
        payment_method: {
            card: cardElement,
            billing_details: {
                name: cardName,
            },
        },
    }).then(function (result) {
        return (result)
    });
}

export const confirmPaymentIntent = async (clientSecret, paymentMethod) => {
    return await stripe.confirmPayment({
        clientSecret: clientSecret,
        redirect: 'if_required',
        confirmParams: {
            payment_method: paymentMethod,
        },
    })
        .then(function (result) {
            return (result)
        });
}

export const confirmPaymentElement = async (successUrl) => {
    return await stripe.confirmPayment({
        elements,
        confirmParams: {
            return_url: successUrl,
        },
    }).then(function (result) {
        return (result)
    });
}